module.exports = __webpack_public_path__ + "img/illustration-success.ac6efb43.svg";